<template>
    <div v-bind:class="'col-md-'+validConfig.col">  
        <div class="form-group">
            <label>{{validConfig.holder}}</label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text ">
                        <i v-if="isError.bool" class="fas fa-keyboard"></i>
                        <i v-else v-on:click="isErrormsg(isError)" class="fa fa-exclamation-triangle text-danger skew-shake-y" style="cursor:pointer"></i>
                    </span>
                </div>
                <input 
                    type="text" 
                    @keyup="removeString" 
                    :id="validConfig.id" 
                    :value="modelValue ?? ''" 
                    @input="$emit('updateValue',($event!.target as HTMLInputElement)!.value,validConfig.name)" 
                    class="form-control" 
                    v-bind:class="isError.class" 
                    :placeholder="validConfig.holder"
                    :disabled="statusInput">
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import {  reactive,toRefs,watchEffect} from "vue";
    import validate from '@/core/composable/useValidate';
    import messages from '@/core/composable/useMessages';
    
    const { longitud } = validate();
    const { validateNotification } = messages();
     
    const props = withDefaults(defineProps<{
        modelValue  :string | null,
        validConfig: {
            value?: string | null,
            validate: boolean,
            name: string,
            message: string,
            col: number,
            min: number,
            max: number,
            empaty: number,
            holder: string,
            id: string
        },  
        statusInput?: boolean
        statusZero?: boolean
        range?: {min:number|null,max:number|null}|null
        
    }>(), {
        statusInput: false,
        statusZero: false,
        range:null,
    });

   
    const emit = defineEmits<{
       (e: 'updateStatus', name: string,status:boolean): void
       (e: 'updateValue', value: string,name:string): void
    }>()

    const { validConfig, modelValue ,statusZero,range} = toRefs(props);
    
    let isError = reactive({ validate: false, class: "", required: validConfig.value.message, bool: true }  );
    
    const isErrormsg = (dto: object) => { validateNotification(dto); }

    const  removeString=()=> {
        let clear = modelValue.value?.replace(/\D/g, '') || '';
        
        if (statusZero.value) {  clear = clear.replace(/^0+/, '') || '0';  }
        
        if (range.value) {
            let num = Number(clear);
            if (range.value.min != null && num < range.value.min) {
                num = range.value.min;
            }
            if (range.value.max != null && num > range.value.max) {
                num = range.value.max;
            }
            clear = String(num);
        }
        
        emit('updateValue', clear, validConfig.value.name);
    }
    
    watchEffect(() => {        
        isError = longitud(modelValue.value??'', validConfig.value.empaty, validConfig.value.min, validConfig.value.max, isError.required);
        if (isError.validate) {              
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value ?? '', validConfig.value.name  );
        } else {       
            
            emit('updateStatus', validConfig.value.name, isError.validate); 
            emit('updateValue',  modelValue.value ?? '', validConfig.value.name);   
        }
    })
</script>
<style>
i.skew-shake-y {
  animation: skew-y-shake 1.3s infinite;
}

@keyframes skew-y-shake {
  0% { transform: skewY(-15deg); }
  5% { transform: skewY(15deg); }
  10% { transform: skewY(-15deg); }
  15% { transform: skewY(15deg); }
  20% { transform: skewY(0deg); }
  100% { transform: skewY(0deg); }  
}
</style>